import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { IoIosWarning } from "react-icons/io";

export default function CheckYourNetworkModal({ isShowModal, handleClose, selectedChain }) {
  if (!isShowModal) {
    return null;
  }

  return (
    <Modal className='network-modal' size="md" centered show={isShowModal} onHide={handleClose}>
      <Modal.Body>
        <div>
          <h2 className='mb-4 mt-2 d-flex align-items-center gap-2 justify-content-center text-body'>
            <b>Check Your Network</b >
            <IoIosWarning size={30} color='#FFC232' />
          </h2>
          <p className='text-muted text-center'>
            To ensure a smooth transaction experience, please make sure <b className="text-dark">Your wallet</b> is connected to the
            <b className="text-dark"> {selectedChain?.chainName}</b> network.
          </p>
          <p className='text-muted text-center mb-0'>
            Mismatched networks may lead to failed transactions or unexpected errors.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button className='px-4' variant="primary" onClick={handleClose}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  )
}